import { Checkbox, FormControlLabel } from '@mui/material';
import * as React from 'react';
import { Status, StatusFilter } from './types';

interface FilterOptionProps {
  statusFilter: StatusFilter;
  active: boolean;
  milestoneFiltersChecked: boolean;
  onStatusFilterToggle: (status: Status) => void;
  currentFilterCount: number;
  totalFilterCount: number;
}

export const FilterOption: React.FC<FilterOptionProps> = (props) => {
  const {
    statusFilter,
    onStatusFilterToggle,
    active,
    currentFilterCount,
    totalFilterCount,
    milestoneFiltersChecked,
  } = props;

  const onChange = React.useCallback(
    () => onStatusFilterToggle(statusFilter.type),
    [onStatusFilterToggle, statusFilter]
  );

  const displayCount = milestoneFiltersChecked ? currentFilterCount : totalFilterCount;

  return (
    <FormControlLabel
      control={
        <Checkbox
          onChange={onChange}
          checked={active}
          size="small"
          className="pr-1"
          disabled={displayCount === 0}
        />
      }
      label={`${statusFilter.label} (${displayCount})`}
      className="pr-4"
    />
  );
};
FilterOption.displayName = 'TrackAndTrace.StatusSelector.FilterOption';
